<template>
  <h2 class="hero__caption" v-html="data.content"/>
</template>

<script>
export default {
  name: 'HomeHeroCaption',
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.hero__caption {
  margin-bottom: 30px;

  text-align: center;
  font-family: $font-family-text;
  font-size: 26px;
  letter-spacing: 2px;
  line-height: 1.2;

  @include mq(ipadP) {
    font-size: 32px;
  }
}
</style>
